import { createClient } from "@supabase/supabase-js";

let supabaseClient;
let authLockChain = Promise.resolve();

const exclusiveAuthLock = async (_name, _acquireTimeout, fn) => {
	const run = authLockChain.then(() => fn(), () => fn());
	authLockChain = run.then(
		() => undefined,
		() => undefined,
	);
	return run;
};

const readRequiredEnv = (name) => {
	const value = (process.env[name] || '').trim();
	if (!value) {
		throw new Error(
			'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in echo_jham_web/.env, then restart npm start.',
		);
	}

	return value;
};

const getSupabaseClient = () => {
	if (!supabaseClient) {
		supabaseClient = createClient(
			readRequiredEnv('REACT_APP_SUPABASE_URL'),
			readRequiredEnv('REACT_APP_SUPABASE_ANON_KEY'),
			{
				auth: {
					lock: exclusiveAuthLock,
				},
			},
		);
	}

	return supabaseClient;
}

export const supabase = new Proxy(
	{},
	{
		get(_target, property) {
			const client = getSupabaseClient();
			const value = client[property];
			return typeof value === 'function' ? value.bind(client) : value;
		},
	},
);